import { defineComponent as _defineComponent } from 'vue'
import InputGroup from '@/components/molecules/input/InputGroup.vue';
import { computed } from 'vue';
import { IFilterField } from './types';

interface Props {
    field: IFilterField;
    value: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterTextField',
  props: {
    field: null,
    value: null
  },
  emits: ["update"],
  setup(__props: any) {

const props = __props as {
    field: IFilterField;
    value: any;
};





const fieldData = computed(() => ({
    label: props.field.label,
    placeholder: props.field.placeholder || props.field.label,
    value: props.value ? String(props.value) : '',
}));


return { __sfc: true,props, fieldData, InputGroup }
}

})